export default __webpack_public_path__ + "static/media/xnft icon_3 1.c8695721.svg";